/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 04/08/2025
 * @update 04/08/2025
 * @file src/components/W06/W06F2520
 */

import { Column, Summary, TotalItem } from "devextreme-react/data-grid";
import {
    Accordion, AccordionDetails, AccordionSummary,
    Attachment,
    Button,
    Checkbox, Col,
    DatePicker,
    Dropdown,
    Modal, ModalBody, ModalFooter, ModalHeader, NumberInput,
    Row, TextInput, Typography, ButtonIcon, Label
} from 'diginet-core-ui/components';
import { makeStyles } from "diginet-core-ui/theme";
import React, { forwardRef, memo, useEffect, useMemo, useRef, useState } from 'react';
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import { bindActionCreators } from "redux";
import { uploadCDN_sync as uploadFileSync } from "../../../actions/file-upload-cdn-async";
import * as userActions from "../../../actions/user-actions";
import * as W06F2520Actions from "../../../actions/w06/w06F2520/w06F2520-actions";
import Config from "../../../config";
import MForm from "../../common/form/form";
import GridContainer from "../../common/grid-container/grid-container";
import { Loading } from "../../common/loading/loadingCore";
import W18F1015CustomerPopUp from "../../W18/W18F1015";
import GridActionBar from "../../common/action-bar/grid-action-bar-hover";
import ButtonExport from "../../common/button/button-export";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
    searchDiv: {
        [theme.breakpoints.down("md")]: {
            paddingTop: theme.spacing(4)
        }
    },
    infoGrid: {
        '& .dx-overlay-wrapper.dx-invalid-message.dx-invalid-message-always.dx-datagrid-invalid-message .dx-overlay-content.dx-resizable': {
            top: '108px !important'
        }
    },
    disabledDropdownCore: {
        '& > div.DGN-UI-Dropdown-Form': {
            backgroundColor: theme.colors.fill.disabled,
            '& span.DGN-UI-Typography': {
            color: theme.colors.system.dark
        }
        },
        
    },
}));

const initialDataMaster = {
    IdentificationID: '',
    CompanyID: '',
    CompanyName: '',
    AddressCus: '',
    BankAccountName: '',
    BankAccountNo: '',
    BankID: '',
    DivisionID: '',
    EmployeeID: '',
    StatusPO: '',
    TransTypeID: '',
    VoucherNo: '',
    VoucherDate: Config.convertDate(new Date(), null, "YYYY-MM-DD"),
    DueDate: null,
    DateFrom: Config.convertDate(new Date(), null, "YYYY-MM-DD"),
    DateTo: null,
    PaymentTermID: '',
    WareHouseID: '',
    PaymentMethodID: '',
    CurrencyID: '',
    PriceListID: '',
    StatusPayment: '',
    Notes: '',
    VatObjectID: '',
    VatAddressCus: '',
    VatNo: '',
    IsPaymentChannels: 0,
    TelePhone: ''
};

const FormID = 'W06F2520';
const requiredField = ['IdentificationID', 'CompanyID', 'DivisionID', 'EmployeeID', 'TransTypeID',
     'VoucherNo', 'VoucherDate', 'WareHouseID', 'CurrencyID', 'PriceListID', 'AddressCus', 'TelePhone', 'BankAccountName', 'BankAccountNo', 'BankID', 'PaymentMethodID'];

const generalBtnProp = {
    size: 'small',
    labelProps: { style: { color: 'initial' } }
};

const arrApiCbo = new Map([
    ['Division', { loading: 'cboDivisionLoading', isDefault: true }],
    ['Trantype', { loading: 'cboTransTypeLoading', isDefault: true }],
    ['Employee', { loading: 'cboEmployeeLoading', isDefault: true }],
    // ['PaymentTerm', { loading: 'cboPaymentTermLoading' }],
    ['PaymentMethodID', { loading: 'cboPaymentMethodLoading' }],
    ['Currency', { loading: 'cboCurrencyLoading', isDefault: true }],
    ['Bank', { loading: 'cboBankLoading', isDefault: true }],
    ['Status'],
]);

const W06F2520 = (props) => {
    const classes = useStyles();
    const { location, decimalSetting } = props;
    const isMobile = window.innerWidth < 576;
    const [isChanged, setIsChanged] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [cboDivisionLoading, setCboDivisionLoading] = useState(false);
    const [cboTransTypeLoading, setCboTransTypeLoading] = useState(false);
    const [cboEmployeeLoading, setCboEmployeeLoading] = useState(false);
    // const [cboPaymentTermLoading, setCboPaymentTermLoading] = useState(false);
    const [cboPaymentMethodLoading, setCboPaymentMethodLoading] = useState(false);
    const [cboCurrencyLoading, setCboCurrencyLoading] = useState(false);
    const [cboBankLoading, setCboBankLoading] = useState(false);
    const [cboStatusLoading, setCboStatusLoading] = useState(false);
    const [openInfoModal, setOpenInfoModal] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [gridLoading, setGridLoading] = useState(false);
    const [showW18F1015, setShowW18F1015] = useState(false);
    const [showUpdateStatusModal, setShowUpdateStatusModal] = useState(false);
    const [customerLoading, setCustomerLoading] = useState(false);
    //const [cboVatObjectLoading, setCboVatObjectLoading] = useState(false);
    const [cboWarehouseLoading, setCboWarehouseLoading] = useState(false);
    const [cboPriceListLoading, setCboPriceListLoading] = useState(false);
    const [showApprovalModal, setShowApprovalModal] = useState(false);
    const [cboStatusPovLoading, setCboStatusPovLoading] = useState([]);

    const [mode, setMode] = useState(location?.state?.mode || 'view');
    const [StrSearch, setStrSearch] = useState('');
    const [error, _setError] = useState({});

    //=======Combo General ===========
    const [dataCboDivision, setDataCboDivision] = useState([]);
    const [dataCboTransType, setDataCboTransType] = useState([]);
    const [dataCboEmployee, setDataCboEmployee] = useState([]);
    // const [dataCboPaymentTerm, setDataCboPaymentTerm] = useState([]);
    const [dataCboPaymentMethod, setDataCboPaymentMethod] = useState([]);
    const [dataCboCurrency, setDataCboCurrency] = useState([]);
    const [dataCboBank, setDataCboBank] = useState([]);
    const [dataCboStatus, setDataCboStatus] = useState([]);
    const [dataCboStatusPov, setDataCboStatusPov] = useState([]);
    //=======Combo General ===========
    const [dataCboWarehouse, setDataCboWarehouse] = useState([]);
    const [dataCboPriceList, setDataCboPriceList] = useState([]);
    const [dataOldAttachments, setDataOldAttachments] = useState([]);
    const [dataMaster, _setDataMaster] = useState(initialDataMaster);
    const [dataGrid, setDataGrid] = useState([]);

    const gridDetailRef = useRef(null);
    const setCustomerStatus = useRef(null);
    const approvalMode = useRef('');
    const dataMasterRef = useRef({ ...initialDataMaster });
    const dataErrorRef = useRef(error);
    const attachments = useRef([]);
    const deletedFile = useRef([]);

    const getInfo = (flag) => {
        if (location?.state) {
            const { mode = 'view', POID = '' } = location?.state || {};
            return {
                mode,
                POID
            }
        } else {
            if (flag) {
                browserHistory.push(Config.env.url + "/W06F2510");
                return null;
            }
            return false;
        }
    };

    const readOnly = mode === 'view';

    useEffect(() => {
        if (!getInfo()) return;
        const checkedType = location?.state?.checkedType || "";
        const identification_id = location?.state?.IdentificationID || "";

        loadDecimalSetting();
        loadGeneralCombo();
        loadCboWareHouse();
        loadCboPriceList();

        //checked localtion
        if (mode !== 'add') {
            loadMaster();
            loadDetail();
            loadAttachment();
        }

        if (checkedType === "IdentificationID") {
            loadGeneralCombo('LoadCustomer', { IdentificationID: identification_id });
            setDataMaster({ IdentificationID: identification_id });
            setIsChanged(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleDefaultModeAdd = () => {
        let objPlus = {};
        for (const [DataTypeID] of Object.entries(Object.fromEntries(arrApiCbo))) {
            if (!arrApiCbo.get(DataTypeID)?.isDefault) continue;
            const dataObj = handleSetLoadingCbo(DataTypeID, [], true) || {};
            objPlus[`${DataTypeID}ID`] = dataObj[`${DataTypeID}ID`] || '';
        }
        objPlus.WareHouseID = dataCboWarehouse?.[0]?.WareHouseID || '';
        objPlus.PriceListID = dataCboPriceList?.[0]?.PriceListID || '';
    };

    const getParamGeneral = (DataTypeID = '', dataRow = {}) => {
        const { POID = '' } = getInfo();
        const { IdentificationID = '', DivisionID = '', PriceListID = '', TransTypeID = '' } = dataMasterRef.current;
        const objResult = {
            DataTypeID,
            TranTypeID: TransTypeID,
            IdentificationID,
            POID,
            DivisionID,
            StrSearch: '',
            PriceListID,
            InventoryID: ''
        };
        if (!Config.isEmpty(dataRow)) {
            const arrParam = Object.keys(objResult);
            const arrDataRow = Object.keys(dataRow);
            for (let i = 0; i < arrDataRow.length; i++) {
                if (arrParam.includes(arrDataRow[i])) objResult[arrDataRow[i]] = dataRow[arrDataRow[i]];
            }
        }
        if (Object.hasOwn(dataRow, 'IdentificationID')) objResult.IdentificationID = dataRow?.IdentificationID;
        return objResult
    };

    const loadCboWareHouse = () => {
        const params = {
            FormID,
            Language: Config.language || '84'
        };
        setCboWarehouseLoading(true);
        props.W06F2520Actions.loadCboWareHouse(params, (error, data) => {
            setCboWarehouseLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (mode === 'add') setDataMaster({ WareHouseID: data?.[0]?.WareHouseID || '' });
                setDataCboWarehouse(data || []);
            }
        });
    };

    const loadCboPriceList = () => {
        const params = {
            FormID,
            DataType: "CmbPriceList",
            TranTypeID: '',
            PaymentMethodID: '',
            PaymentTermID: '',
            CurrencyID: ''
        }
        setCboPriceListLoading(true);
        props.W06F2520Actions.loadCboPriceList(params, (error, data) => {
            setCboPriceListLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataCboPriceList(data || []);
                setDataMaster({ PriceListID: data?.[0]?.PriceListID || '' });
            }
        });
    };

    const loadDecimalSetting = () => {
        props.W06F2520Actions.loadDecimalSetting((error) => {
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            }
        });
    };

    const loadMaster = (pOID) => {
        const params = getParamGeneral('LoadMaster');
        if (pOID) params.POID = pOID;
        setFormLoading(true);
        props.W06F2520Actions.loadMaster(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const dataObj = data?.[0] || {};
                setDataMaster({ ...dataObj, StatusPaymentColor: (dataObj?.StatusPayment_Color || '') }, true);
            }
        });
    };

    const loadDetail = (pOID) => {
        const params = getParamGeneral('LoadDetail');
        if (pOID) params.POID = pOID;
        setGridLoading(true);
        props.W06F2520Actions.loadDetail(params, (error, data) => {
            setGridLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataGrid(data?.[0] || []);
            }
        });
    };

    const loadAttachment = () => {
        const params = getParamGeneral('LoadAttached');
        props.W06F2520Actions.loadAttachment(params, (error, data) => {
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataOldAttachments(data || []);
            }
        });
    };

    const onPayment = () => {
        const { POID = '' } = getInfo();
        const { DivisionID = '', TransTypeID: TranTypeID = '', IdentificationID = '', PriceListID = '', IsPaymentChannels = 0 } = dataMaster;
        const params = {
            DivisionID,
            TranTypeID,
            IdentificationID,
            POID,
            PriceListID,
            StrSearch: '',
            IsPaymentChannels,
        };
        setFormLoading(true);
        props.W06F2520Actions.paymentRequest(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const { Status, Message = '' } = data || {};
                if (Status === 0 && Message) Config.popupCore.show('INFO', Message);
                if (Status === 1 && Message) Config.popupCore.show('ERROR', Message);
                loadMaster();
                loadDetail();
                loadAttachment();
            }
        });
    };

    const handleChangeCustomer = (data = {}, isClearIdentification = false) => {
        if (!setCustomerStatus.current) return;
        let dataState = {};
        let errPlus = {};
        const arrState = ['DueDate', 'CompanyID', 'CompanyName', 'CompanyNameU', 'PaymentMethodID', 'PaymentTermID', 'AddressCus', 'BankAccountName', 'BankAccountNo', 'TelePhone'];
        for (const name in data) {
            let key = name;
            let isDate = (name.toLowerCase()).indexOf('date') > -1;
            const value = data?.[name] || (isDate ? null : '');
            if (name === 'CompanyNameU') key = 'CompanyName';
            if (arrState.includes(name)) dataState[key] = value;
            if (error?.[key] && !Config.isEmpty(value)) errPlus[key] = '';
        }
        if (isClearIdentification) dataState['IdentificationID'] = '';
        setDataMaster(dataState);
        if(!Config.isEmpty(errPlus)) setError(errPlus);
    };

    /*
    @status (boolean/array): Nếu status type là boolean thì set loading còn array là set dataSource 
    */
    const handleSetLoadingCbo = (DataTypeID = '', status, isResetDefault = false) => {
        let valueObj = {};
        const isAdd = mode === 'add';
        const isBoolean = Config.typeOf(status, 'boolean');
        switch (DataTypeID) {
            case 'LoadCustomer':
                if (isBoolean) setCustomerLoading(status);
                else {
                    const { IdentificationID } = dataMasterRef.current;
                    if (!Config.isEmpty(status)) {
                        setCustomerStatus.current = true;
                        handleChangeCustomer(status);
                    } else if (!Config.isEmpty(IdentificationID)) { // Nếu API không trả ra dòng nào gọi form W17F1026 sau khi lưu data ở form W17F1026 gọi lại màn hình W17F2040
                        Config.popupCore.show('YES_NO', Config.lang('Khach_hang_khong_ton_tai,_ban_co_muon_them_moi_khong!'), () => {
                            browserHistory.push({
                                pathname: Config.getRootPath() + 'W17F1026',
                                state: {
                                    mode: 'add',
                                    type: 'Customer',
                                    parentForm: 'W06F2520',
                                    parentMode: getInfo()?.mode || '',
                                    parentPOID: getInfo()?.POID || '',
                                    checkedType: "IdentificationID",
                                }
                            })
                        }, () => {
                            handleChangeCustomer({}, true);
                            setCustomerStatus.current = false;
                        });
                    } else {
                        handleChangeCustomer();
                        setCustomerStatus.current = false;
                    }
                }
                break;
            case 'Division':
                if (isBoolean) setCboDivisionLoading(status);
                else {
                    if (isAdd) setDataMaster({ DivisionID: status?.[0]?.DivisionID || '' });
                    else if (isResetDefault) valueObj.DivisionID = dataCboDivision?.[0]?.DivisionID || '';
                    setDataCboDivision(status || []);
                }
                break;
            case 'Trantype':
                if (isBoolean) setCboTransTypeLoading(status);
                else {
                    if (isAdd) {
                        setDataMaster({ TransTypeID: status?.[0]?.TranTypeID || '' });
                        loadVoucher(status?.[0]?.TranTypeID || '');
                    } else if (isResetDefault) {
                        valueObj.TransTypeID = dataCboTransType?.[0]?.TranTypeID || '';
                        loadVoucher(dataCboTransType?.[0]?.TranTypeID || '');
                    }
                    setDataCboTransType(status || []);
                }
                break;
            case 'Employee':
                if (isBoolean) setCboEmployeeLoading(status);
                else {
                    if (isAdd) setDataMaster({ EmployeeID: status?.[0]?.EmployeeID || '' });
                    else if (isResetDefault) valueObj.EmployeeID = dataCboEmployee?.[0]?.EmployeeID || '';
                    setDataCboEmployee(status || []);
                }
                break;
            // case 'PaymentTerm':
            //     if (isBoolean) setCboPaymentTermLoading(status);
            //     else setDataCboPaymentTerm(status || []);
            //     break;
            case 'PaymentMethodID':
                if (isBoolean) setCboPaymentMethodLoading(status);
                else {
                    if (isAdd) setDataMaster({ PaymentMethodID: status?.[0]?.PaymentMethodID || '' });
                    else if (isResetDefault) valueObj.PaymentMethodID = dataCboPaymentMethod?.[0]?.PaymentMethodID || '';
                    setDataCboPaymentMethod(status || []);
                }
                break;
            case 'Currency':
                if (isBoolean) setCboCurrencyLoading(status);
                else {
                    if (isAdd) setDataMaster({ CurrencyID: status?.[0]?.ID || '' });
                    else if (isResetDefault) valueObj.CurrencyID = dataCboCurrency?.[0]?.ID || '';
                    setDataCboCurrency(status || []);
                }
                break;
            case 'Bank':
                if (isBoolean) setCboBankLoading(status);
                else {
                    if (isAdd) setDataMaster({ BankID: status?.[0]?.BankID || '' });
                    else if (isResetDefault) valueObj.BankID = dataCboBank?.[0]?.BankID || '';
                    setDataCboBank(status || []);
                }
                break;
            case 'Status':
                if (isBoolean) setCboStatusLoading(status);
                else setDataCboStatus(status || []);
                break;
            case 'StatusPov':
                if (isBoolean) setCboStatusPovLoading(status);
                else setDataCboStatusPov(status || []);
                break;
            default:
                break;
        }
        return valueObj;
    };

    const loadGeneralCombo = (apiName = '', dataRow) => {
        const params = getParamGeneral('', dataRow);
        let apiCboArr = arrApiCbo;
        if (!Config.isEmpty(apiName)) apiCboArr = new Map([[apiName]]);
        for (const [DataTypeID] of Object.entries(Object.fromEntries(apiCboArr))) {
            params.DataTypeID = DataTypeID;
            if (DataTypeID === 'Division') params.InventoryID = dataRow?.InventoryID || '';
            handleSetLoadingCbo(DataTypeID, true);
            props.W06F2520Actions.loadCombo(params, (error, data) => {
                handleSetLoadingCbo(DataTypeID, false);
                if (error) {
                    Config.popupCore.show('ERROR', error);
                    return false;
                } else if (data) {
                    handleSetLoadingCbo(DataTypeID, data || []);
                }
            });
        }
    };

    const loadVoucher = (TranTypeID = '') => {
        const params = getParamGeneral('LoadVoucherNo', { TranTypeID });
        setCboTransTypeLoading(true);
        props.W06F2520Actions.loadVoucher(params, (err, data) => {
            setCboTransTypeLoading(false);
            if (err) {
                Config.popupCore.show('ERROR', err);
                return false;
            } else if (data) {
                if (!Config.isEmpty(data?.VoucherNo) && error?.VoucherNo) setError({ VoucherNo: '' });
                setDataMaster({ VoucherNo: data?.VoucherNo || '' });
            }
        });
    };

    const setDataMaster = (dataObj = {}, isReset = false) => {
        dataMasterRef.current = isReset ? { ...dataObj } : { ...dataMasterRef.current, ...dataObj };
        _setDataMaster(dataMasterRef.current);
    };

    const setError = (dataError = {}, isReset = false) => {
        dataErrorRef.current = isReset ? { ...dataError } : { ...dataErrorRef.current, ...dataError };
        _setError(dataErrorRef.current);
    };

    const _uploadFile = (files) => {
        const cdnToken = Config.decryptData(Config.getLocalStorage('CDN_TOKEN'));
        return uploadFileSync(files, 'multiple', cdnToken);
    };

    const _getAttachments = (file) => {
        const dataFile = file?.data?.paths || [];
        const listAttachments = Config.helpers.getFileInfomations(dataFile);
        let arrAttachment = [];
        listAttachments.forEach((att) => {
            arrAttachment.push({
                URL: att.url ? att.url : "",
                FileName: att.fileName ? att.fileName : "",
                FileSize: att.fileSize ? att.fileSize : "",
                FileExt: att.fileName ? att.fileName.split(".").pop() : "",
            });
        });
        if (dataOldAttachments && dataOldAttachments.length > 0) {
            arrAttachment = dataOldAttachments.concat(arrAttachment);
        }
        return arrAttachment;
    };

    const checkEdit = () => {
        const params = getParamGeneral('CheckEdit');
        setFormLoading(true);
        props.W06F2520Actions.checkEdit(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (data?.Status === 0) onReset('edit', true);
                else if (data?.Status === 1 && data.Message) Config.popupCore.show('INFO', data.Message);
            }
        });
    };

    const checkValidateMaster = (arrName) => {
        if (Config.isEmpty(arrName)) return;
        return arrName.map(item => {
            let val = dataMaster[item];
            return {
                name: item,
                rules: ["isRequired"],
                value: val
            }
        });
    };

    const onSave = async () => {
        let detail = [];
        const resultValidate = checkValidateMaster(requiredField);
        const validateFrom = MForm.formValidation(resultValidate);
        if (Object.keys(validateFrom).length > 0) {
            setError(validateFrom, true);
            return false;
        }
        const dataResUploadFile = await _uploadFile(attachments.current, true);
        const arrAttachment = _getAttachments(dataResUploadFile);
        await gridDetailRef.current.instance.saveEditData();
        detail = gridDetailRef.current.instance.option('dataSource') || [];
        const params = {
            ...dataMaster,
            detail,
            arrAttachment,
        };
        setFormLoading(true);
        props.W06F2520Actions.onSave(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (data?.Status === 0) {
                    setSaveSuccess(true);
                    setMode('view');
                    //remove route history
                    browserHistory.replace({
                        pathname: Config.getRootPath() + 'W06F2520',
                        state: {
                            mode: getInfo()?.mode || '',
                            POID: data?.POID || '',
                        }
                    })
                    loadMaster(data?.POID);
                    loadDetail(data?.POID);
                    Config.notify.show('success', Config.lang('Luu_thanh_cong'), 2000);
                } else if (data?.Message) Config.popupCore.show('INFO', data.Message);
            }
        });
    };


    const handleOpenApproval = (mode = '', status) => {
        approvalMode.current = mode;
        setShowApprovalModal(status);
    };

    const calculateRateAmount = (colName = '', dataRow = {}, e) => {
        let DataTypeID = '';
        if (colName === 'RateDiscount') DataTypeID = 'LoadData_grid_rate';
        if (colName === 'AmountDiscount') DataTypeID = 'LoadData_grid_Amount';
        const params = { ...(getParamGeneral(DataTypeID, { IdentificationID: '' }) || {}), ...dataRow };
        props.W06F2520Actions.calculateRateAmount(params, (error, data) => {
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (!Config.isEmpty(data) && !Config.isEmpty(dataRow?.rowIndex) && e) {
                    const arrData = Object.keys(data);
                    const { oldData = {} } = e || {};
                    for (let i = 0; i < arrData.length; i++) {
                        const name = arrData[i];
                        oldData[name] = data[name];
                    }
                    setTimeout(gridDetailRef.current.instance.refresh(), 300);
                }
            }
        });
    };

    const goBack = () => {
        browserHistory.push(Config.env.url + "/W06F2510");
    };

    const handleOpenUpdateStatusModal = (status = false, isReload = false) => {
        if (status) loadGeneralCombo('StatusPov');
        if (isReload) loadMaster(); // Load lại form 
        setShowUpdateStatusModal(status);
    };

    const handleOpenInfoModal = async (status = false, dataChoose = []) => {
        const { CurrencyID, PriceListID } = dataMaster;
        if (status && (Config.isEmpty(CurrencyID) || Config.isEmpty(PriceListID))) {
            Config.popupCore.show('INFO', `${Config.lang('Vui_long_chon')}: ${Config.lang('Bang_gia_mua')}, ${Config.lang('Loai_tien')}`);
            return;
        }
        if (!!status) { // Open
            if (gridDetailRef.current) {
                await gridDetailRef.current.instance.saveEditData();
                const newDataGrid = gridDetailRef.current.instance.option('dataSource') || [];
                setDataGrid(newDataGrid);
                setTimeout(() => setOpenInfoModal(status), 300);
            }
        } else {
            setOpenInfoModal(status);
            if (!Config.isEmpty(dataChoose)) {
                setIsChanged(true);
                setDataGrid(dataChoose);
            }
        }
    };

    const onChange = (keyName, e) => {
        if (!e || !keyName) return;
        let value = e?.value ?? e?.target?.value ?? '';
        if (Config.isEmpty(value) && ['DateFrom', 'DateTo'].includes(keyName)) value = null;
        let objPlus = { [keyName]: value };
        switch (keyName) {
            case 'TransTypeID':
                if (Config.isEmpty(value)) {
                    objPlus.VoucherNo = '';
                } else loadVoucher(value);
                break;
            default:
                break;
        }
        setIsChanged(true);
        setDataMaster(objPlus);
        if (error?.[keyName] && !Config.isEmpty(value)) setError({ [keyName]: '' });
    };

    const onChangeFilter = (fieldName, e) => {
        if (Config.isEmpty(fieldName)) return;
        let value = e?.value ?? e?.target?.value ?? '';
        setStrSearch(value);
        loadMaster(['Data'], value);
    };

    const renderNumberInputCol = (e, mode = 'view') => {
        if (!e) return false;
        let digit = 8;
        const { column: { dataField = "" } } = e || {};
        const decimalValue = e?.value;
        let objProps = {
            viewType: 'none',
            decimalDigit: digit,
            thousandSeparator: ',',
            inputStyle: { textAlign: 'right' },
            delayOnChange: 1,
        }
        switch (dataField) {
            case 'CQuantity':
                objProps.decimalDigit = decimalSetting?.D07_ConvertedDecimals ?? digit;
                break;
            case 'UnitPrice':
                objProps.decimalDigit = decimalSetting?.UnitPriceDecimals ?? digit;
                break;
            case 'CAmount':
            case 'VatCAmount':
            case 'TotalCAmount':
                objProps.decimalDigit = decimalSetting?.D90_ConvertedDecimals ?? digit;
                break;
            case 'RateDiscount':
                objProps.min = -100;
                objProps.max = 100;
                objProps.disabledNegative = false;
                objProps.decimalDigit = decimalSetting?.ExchangeRateDecimals ?? digit;
                break;
            case 'AmountDiscount':
                objProps.disabledNegative = false;
                break;
            default:
                break;
        }
        if (mode === 'edit') objProps.onChange = (c) => e.setValue(c.value);
        return <NumberInput
            nonStyle
            {...(['RateDiscount', 'AmountDiscount'].includes(dataField) ? {} : { disabledNegative: true })}
            readOnly={mode !== 'edit'}
            value={decimalValue}
            {...objProps}
        />
    };

    const renderPercentNumberInputCol = (e) => {
        if (!e) return false;
        return `${Config.numberFormat(e?.value, decimalSetting?.ExchangeRateDecimals ?? 4)} %`;
    };

    const onChangeAttachments = e => {
        setIsChanged(true);
        attachments.current = e.allNewAttached ? e.allNewAttached : [];
        // Xử lý xóa đính kèm
        if (e.removedAttached && e.removedAttached.length > 0) {
            deletedFile.current = [...e.removedAttached];
            const _arrRemove = deletedFile.current.map(d => d.AttachmentID);
            setDataOldAttachments(
                dataOldAttachments.filter(att => {
                    return _arrRemove.indexOf(att.AttachmentID) < 0;
                })
            );
        }
    };

    const handleHide18F1015 = (e = {}) => {
        if (!Config.isEmpty(e?.data)) {
            const { CompanyID = '', CompanyNameU: CompanyName = '', DueDate = null, AddressCus = '', BankID = '', BankAccountNo = '', BankAccountName = '', PaymentTermID = '', PaymentMethodID = '',
                TelePhone = '' } = e?.data || {};
            setDataMaster({
                AddressCus,
                BankAccountName,
                BankAccountNo,
                BankID,
                CompanyID,
                CompanyName,
                DueDate,
                PaymentTermID,
                PaymentMethodID,
                TelePhone
            });
            if (error?.CompanyID) setError({ CompanyID: '' });
            setIsChanged(true);
        }
        setShowW18F1015(false);
    };

    const deleteRow = (e) => {
        if (!e) return;
        Config.popupCore.show('YES_NO', Config.lang('Ban_co_chac_muon_xoa?'), async () => {
            e.component.deleteRow(e.rowIndex);
            gridDetailRef.current.instance.refresh();
            setIsChanged(true);
        });
    };

    const renderAction = (e) => {
        return (
            <GridActionBar>
                <ButtonIcon
                    circular
                    disabled={gridLoading || readOnly}
                    name={'Delete'}
                    size={'small'}
                    viewType={'text'}
                    onClick={() => deleteRow(e)} />
            </GridActionBar>
        );
    };

    const onReset = (modeProp, isNotResetData = false) => {
        if (!isNotResetData) {
            setDataMaster(initialDataMaster, true);
            setDataGrid([]);
        }
        setIsChanged(false);
        setSaveSuccess(false);
        if (modeProp === 'add') handleDefaultModeAdd(); // Xử lý Sét default các combo khi mode là Thêm mới
        setMode(modeProp);
    };

    const renderGrid = useMemo(() => {
        const dataSource = dataGrid.map((item, idx) => ({ ...item, STT: idx }));
        return (
            <GridContainer
                reference={ref => gridDetailRef.current = ref}
                pagerFullScreen={false}
                dataSource={dataSource}
                loading={gridLoading}
                keyExpr={'STT'}
                typePaging={'normal'}
                itemPerPage={20}
                onRowUpdated={() => setIsChanged(true)}
                elementAttr={{ style: 'max-height: 520px; min-height: 320px' }}
                filterRow={{
                    visible: false,
                    showOperationChooser: false,
                }}
                onRowUpdating={(e) => {
                    const { newData = {}, oldData = {} } = e;
                    const columnName = (Object.keys(newData))[0];
                    if (['Quantity'].includes(columnName)) {
                        const { CurrencyID } = dataMasterRef.current;
                        const { ExchangeRate = null } = dataCboCurrency.find(item => item?.ID === CurrencyID) || {};
                        const { Quantity = null, VatRate = null, UnitPrice = null, ConversionFactor = null } = { ...oldData, ...newData };
                        const OAmountVal = Quantity * UnitPrice;
                        const CAmountVal = OAmountVal * ExchangeRate;
                        const VatOAmountVal = OAmountVal * VatRate;
                        const VatCAmountVal = CAmountVal * VatRate;
                        oldData['OAmount'] = OAmountVal;
                        oldData['CAmount'] = OAmountVal * ExchangeRate;
                        oldData['VatOAmount'] = VatOAmountVal;
                        oldData['VatCAmount'] = VatCAmountVal;
                        oldData['TotalOAmount'] = OAmountVal + VatOAmountVal;
                        oldData['TotalCAmount'] = CAmountVal + VatCAmountVal;
                        oldData['CQuantity'] = Quantity * ConversionFactor;
                    } else if (['RateDiscount', 'AmountDiscount'].includes(columnName)) {
                        calculateRateAmount(columnName, { ...oldData, ...newData, rowIndex: e?.key }, e);
                    }
                }}
                editing={{
                    mode: 'cell',
                    refreshMode: 'reshape',
                    allowUpdating: !readOnly,
                    texts: { confirmDeleteMessage: '' },
                    startEditAction: 'click',
                }}>
                <Column allowEditing={false} width={90} fixed allowSorting={false} cellRender={renderAction} caption={Config.lang('Hanh_dong')} alignment={'center'} visible={Config.isMobile} />
                <Column allowEditing={false} width={200} caption={Config.lang('Ma_hang')} dataField={'InventoryID'} />
                <Column allowEditing={false} minWidth={250} caption={Config.lang('Ten_hang_hoa')} dataField={'InventoryName'} />
                <Column allowEditing={false} width={120} caption={Config.lang('DVT')} dataField={'UnitID'} />
                <Column allowEditing={false} width={180} caption={Config.lang('Don_gia_mua')} dataField={'UnitPrice'} cellRender={renderNumberInputCol} />
                <Column width={100} caption={Config.lang('So_luong')} dataField={'Quantity'} dataType={'number'} cellRender={renderNumberInputCol} editCellRender={(e) => renderNumberInputCol(e, 'edit')} />
                <Column allowEditing={false} width={170} caption={Config.lang('Thanh_tien(NT)')} dataField={'OAmount'} dataType={'number'} cellRender={renderNumberInputCol} editCellRender={(e) => renderNumberInputCol(e, 'edit')} />
                <Column minWidth={250} caption={Config.lang('Ghi_chu')} dataField={'DetailNotes'} />
                <Column width={170} caption={Config.lang('Ty_le(tang/giam)')} dataField={'RateDiscount'} dataType={'number'} cellRender={renderPercentNumberInputCol} editCellRender={(e) => renderNumberInputCol(e, 'edit')} />
                <Column width={170} caption={Config.lang('Thanh_tien(tang/giam)')} dataField={'AmountDiscount'} dataType={'number'} cellRender={renderNumberInputCol} editCellRender={(e) => renderNumberInputCol(e, 'edit')} />
                <Column allowEditing={false} width={180} caption={Config.lang('Tong_thanh_toan(NT)')} dataField={'TotalOAmount'} dataType={'number'} cellRender={renderNumberInputCol} editCellRender={(e) => renderNumberInputCol(e, 'edit')} />
                <Column visible={false} allowEditing={false} width={160} caption={Config.lang('So_luong_QD')} dataField={'CQuantity'} dataType={'number'} cellRender={renderNumberInputCol} editCellRender={(e) => renderNumberInputCol(e, 'edit')} />
                <Column visible={false} dataField={'ConversionFactor'} />
                <Column visible={false} allowEditing={false} width={170} caption={Config.lang('Thanh_tien(QD)')} dataField={'CAmount'} dataType={'number'} cellRender={renderNumberInputCol} editCellRender={(e) => renderNumberInputCol(e, 'edit')} />
                <Column visible={false} allowEditing={false} width={150} caption={Config.lang("Ngay_giao_hang")} dataField={'DeliveryDate'} alignment={'center'} dataType={'date'} format={'dd/MM/yyyy'} />
                <Column visible={false} allowEditing={false} width={170} caption={Config.lang('Nhom_thue')} dataField={'VatGroup'} />
                <Column visible={false} allowEditing={false} width={170} caption={Config.lang('Thue_suat')} dataField={'VatRate'} dataType={'number'} cellRender={renderNumberInputCol} editCellRender={(e) => renderNumberInputCol(e, 'edit')} />
                <Column visible={false} allowEditing={false} width={170} caption={Config.lang('Tien_thue(NT)')} dataField={'VatOAmount'} dataType={'number'} cellRender={renderNumberInputCol} editCellRender={(e) => renderNumberInputCol(e, 'edit')} />
                <Column visible={false} allowEditing={false} width={170} caption={Config.lang('Tien_thue(QD)')} dataField={'VatCAmount'} dataType={'number'} cellRender={renderNumberInputCol} editCellRender={(e) => renderNumberInputCol(e, 'edit')} />
                <Column visible={false} allowEditing={false} width={180} caption={Config.lang('Tong_thanh_toan(QD)')} dataField={'TotalCAmount'} dataType={'number'} cellRender={renderNumberInputCol} editCellRender={(e) => renderNumberInputCol(e, 'edit')} />
                <Column allowEditing={false} width={50} fixed alignment={"right"} fixedPosition={"right"} visible={!Config.isMobile} cellRender={renderAction}
                />
                <Summary>
                    <TotalItem
                        column={'Quantity'} // So_luong
                        summaryType={'sum'}
                        displayFormat={"{0}"}
                        valueFormat={(e) => Config.numberFormat(e, 8)}
                    />
                    <TotalItem
                        column={'AmountDiscount'} // Thanh_tien(tang/giam)
                        summaryType={'sum'}
                        displayFormat={"{0}"}
                        valueFormat={(e) => Config.numberFormat(e, 8)}
                    />
                    <TotalItem
                        column={'OAmount'} // Thanh_tien(NT)
                        summaryType={'sum'}
                        displayFormat={"{0}"}
                        valueFormat={(e) => Config.numberFormat(e, 8)}
                    />
                    <TotalItem
                        column={'CAmount'} // Thanh_tien(QD)
                        summaryType={'sum'}
                        displayFormat={"{0}"}
                        valueFormat={(e) => Config.numberFormat(e, decimalSetting?.D90_ConvertedDecimals ?? 8)}
                    />
                    <TotalItem
                        column={'VatOAmount'} // Tien_thue(NT)
                        summaryType={'sum'}
                        displayFormat={"{0}"}
                        valueFormat={(e) => Config.numberFormat(e, 8)}
                    />
                    <TotalItem
                        column={'VatCAmount'} // Tien_thue(QD)
                        summaryType={'sum'}
                        displayFormat={"{0}"}
                        valueFormat={(e) => Config.numberFormat(e, decimalSetting?.D90_ConvertedDecimals ?? 8)}
                    />
                    <TotalItem
                        column={'TotalOAmount'} // Tong_thanh_toan(NT)
                        summaryType={'sum'}
                        displayFormat={"{0}"}
                        valueFormat={(e) => Config.numberFormat(e, 8)}
                    />
                    <TotalItem
                        column={'TotalCAmount'} // Tong_thanh_toan(QD)
                        summaryType={'sum'}
                        displayFormat={"{0}"}
                        valueFormat={(e) => Config.numberFormat(e, decimalSetting?.D90_ConvertedDecimals ?? 8)}
                    />
                </Summary>
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataGrid, decimalSetting, gridLoading, readOnly, dataCboCurrency, mode]);

    const paramPrint = [
        { type: "Varchar", id: "UserID", value: Config.profile?.UserID || '' },
        { type: "Varchar", id: "Language", value: Config.language || '84' },
        { type: "VarChar", id: "DivisionID", value: dataMaster?.DivisionID },
        { type: "VarChar", id: "DataType", value: "Export_SalesOrder" },
        { type: "VarChar", id: "POID", value: getInfo()?.POID || '' },
    ];

    if (!getInfo(true)) return null;
    return (
        <div className={'page-container'}>
            <Loading visible={formLoading} />
            <Row>
                {openInfoModal && <InfoModal
                    open={openInfoModal}
                    handleOpen={(status, dataChoose) => handleOpenInfoModal(status, dataChoose)}
                    dataForm={dataMasterRef.current}
                    getParamGeneral={getParamGeneral}
                    renderNumberInputCol={renderNumberInputCol}
                    dataGridParent={dataGrid}
                    {...props}
                />}
                {showW18F1015 && <W18F1015CustomerPopUp
                    mode={1}
                    formID={FormID}
                    typeID={"AddSO"}
                    tranTypeID={dataMaster?.TransTypeID}
                    onHide={(data, dataInventory) => {
                        handleHide18F1015({ data, dataInventory });
                    }}
                />}
                {showUpdateStatusModal && <UpdateStatusModal
                    open={showUpdateStatusModal}
                    dataCboStatusPov={dataCboStatusPov}
                    dataCboStatusPovLoading={cboStatusPovLoading}
                    handleOpen={(status, isReload) => handleOpenUpdateStatusModal(status, isReload)}
                    paramSave={() => getParamGeneral('UDT_Status')}
                    {...props}
                />}
                {showApprovalModal && <ApprovalModal
                    open={showApprovalModal}
                    loadMaster={loadMaster}
                    loadDetail={loadDetail}
                    approvalMode={approvalMode.current}
                    handleOpen={(status, isReload) => handleOpenApproval(status, isReload)}
                    paramSave={() => getParamGeneral(approvalMode.current, { IdentificationID: '' })}
                    {...props}
                />}
                <Col xs={12}><Typography color={"info"} type={"h4"}>{Config.lang("Lap_don_hang_mua")}</Typography></Col>
                <Col xs={12}>
                    <div className={'wrap align-center'}>
                        <Button
                            {...generalBtnProp}
                            color={'warning'}
                            startIcon={'Back'}
                            label={Config.lang('Quay_lai')}
                            onClick={() => goBack()}
                        />
                        <Button
                            {...generalBtnProp}
                            color={'info'}
                            startIcon={"Add"}
                            className={"mgl1x"}
                            label={Config.lang('Nhap_tiep')}
                            disabled={mode === "add"}
                            onClick={() => onReset('add')}
                        />
                        <Button
                            {...generalBtnProp}
                            color={'info'}
                            startIcon={"Save"}
                            className={"mgl1x"}
                            label={Config.lang('Luu')}
                            disabled={readOnly || saveSuccess || !isChanged}
                            onClick={() => onSave()}
                        />
                        <Button
                            {...generalBtnProp}
                            color={'info'}
                            startIcon={"Edit"}
                            className={"mgl1x"}
                            label={Config.lang('Sua')}
                            disabled={(mode === "edit" && !saveSuccess) || mode === 'add'}
                            onClick={() => checkEdit()}
                        />
                        <Button
                            {...generalBtnProp}
                            color={'success'}
                            className={'mgl1x'}
                            startIcon={'Approval'}
                            label={Config.lang('Duyet')}
                            disabled={mode !== 'view' || dataMaster?.IsApproval !== 1}
                            onClick={() => handleOpenApproval('Approval', true)}
                        />
                        <Button
                            {...generalBtnProp}
                            color={'danger'}
                            className={'mgl1x'}
                            startIcon={'CancelFilled'}
                            label={Config.lang('Bo_duyet')}
                            disabled={mode !== 'view' || dataMaster?.IsUnApproval !== 1}
                            onClick={() => handleOpenApproval('UNApproval', true)}
                        />
                        <ButtonExport
                            isPreview
                            onlyShowPopup
                            className={'mgl1x'}
                            disabled={mode === 'add' || dataMaster?.IsPrint === 0}
                            name={Config.lang('In1')}
                            transTypeID={'Export_Quotation'}
                            reportTypeID={'W06F2520'}
                            param={paramPrint}
                        />
                        <Button
                            {...generalBtnProp}
                            color={'primary'}
                            className={'mgl1x'}
                            startIcon={'Payment'}
                            label={Config.lang('Yeu_cau_thanh_toan')}
                            disabled={mode !== 'view' || dataMaster?.IsPayment !== 0}
                            onClick={() => onPayment()}
                        />
                        <Button
                            {...generalBtnProp}
                            color={'primary'}
                            className={'mgl1x'}
                            startIcon={"SyncHorizontal"}
                            label={Config.lang('Cap_nhat_trang_thai')}
                            disabled={mode !== 'view'}
                            onClick={() => handleOpenUpdateStatusModal(true)}
                        />
                    </div>
                </Col>
                <Accordion expand>
                    <AccordionSummary>{Config.lang('Thong_tin_chung_tu')}</AccordionSummary>
                    <AccordionDetails>
                        <Row>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <TextInput
                                    // required
                                    readOnly={readOnly || customerLoading}
                                    viewType={'outlined'}
                                    delayOnChange={700}
                                    error={error?.IdentificationID}
                                    value={dataMaster?.IdentificationID}
                                    label={Config.lang('CCCD/HC')}
                                    onChange={e => onChange('IdentificationID', e)}
                                    onKeyDown={(e) => e?.keyCode === 13 && loadGeneralCombo('LoadCustomer', { IdentificationID: dataMasterRef.current?.IdentificationID })}
                                />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <TextInput
                                    readOnly
                                    // required
                                    disabled
                                    viewType={'outlined'}
                                    endIcon={'ArrowDown'}
                                    value={dataMaster?.CompanyName}
                                    error={error?.CompanyID}
                                    label={Config.lang('Khach_hang')}
                                    // {...(readOnly ? {} : { onClick: () => setShowW18F1015(true) })}
                                />
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={6}>
                                <TextInput
                                    readOnly={readOnly}
                                    viewType={'outlined'}
                                    value={dataMaster?.AddressCus}
                                    label={Config.lang('Dia_chi')}
                                    error={error?.AddressCus}
                                    onChange={e => onChange('AddressCus', e)}
                                />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <TextInput
                                    readOnly={readOnly}
                                    viewType={'outlined'}
                                    value={dataMaster?.TelePhone}
                                    label={Config.lang('So_dien_thoai')}
                                    error={error?.TelePhone}
                                    onChange={e => onChange('TelePhone', e)}
                                />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <TextInput
                                    readOnly={readOnly}
                                    viewType={'outlined'}
                                    disabled
                                    value={dataMaster?.BankAccountName}
                                    label={Config.lang('Ten_thu_huong')}
                                    error={error?.BankAccountName}
                                    onChange={e => onChange('BankAccountName', e)}
                                />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <TextInput
                                    readOnly={readOnly}
                                    viewType={'outlined'}
                                    value={dataMaster?.BankAccountNo}
                                    label={Config.lang('So_tai_khoan')}
                                    error={error?.BankAccountNo}
                                    onChange={e => onChange('BankAccountNo', e)}
                                />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <Dropdown
                                    // required
                                    viewType={'outlined'}
                                    valueExpr={'BankID'}
                                    displayExpr={'BankAccountName'}
                                    label={Config.lang('Ngan_hang')}
                                    readOnly={readOnly}
                                    loading={cboBankLoading}
                                    dataSource={dataCboBank}
                                    error={error?.BankID}
                                    value={dataMaster?.BankID}
                                    onChange={e => onChange('BankID', e)}
                                />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <Dropdown
                                    // required
                                    viewType={'outlined'}
                                    valueExpr={'DivisionID'}
                                    displayExpr={'DivisionName'}
                                    label={Config.lang('Diem_ban_hang')}
                                    readOnly={readOnly}
                                    disabled={mode === 'edit'}
                                    loading={cboDivisionLoading}
                                    dataSource={dataCboDivision}
                                    error={error?.DivisionID}
                                    value={dataMaster?.DivisionID}
                                    onChange={e => onChange('DivisionID', e)}
                                />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <Dropdown
                                    // required
                                    viewType={'outlined'}
                                    valueExpr={'EmployeeID'}
                                    displayExpr={'EmployeeName'}
                                    label={Config.lang('Nhan_vien')}
                                    readOnly={readOnly}
                                    disabled={mode === 'edit'}
                                    loading={cboEmployeeLoading}
                                    dataSource={dataCboEmployee}
                                    error={error?.EmployeeID}
                                    value={dataMaster?.EmployeeID}
                                    onChange={e => onChange('EmployeeID', e)}
                                />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <Dropdown
                                    // required
                                    // disabled
                                    // className={classes.disabledDropdownCore}
                                    viewType={'outlined'}
                                    valueExpr={'PriceListID'}
                                    displayExpr={'DescriptionU'}
                                    label={Config.lang('Bang_gia_mua')}
                                    readOnly={readOnly}
                                    loading={cboPriceListLoading}
                                    dataSource={dataCboPriceList}
                                    error={error?.PriceListID}
                                    value={dataMaster?.PriceListID}
                                    onChange={e => onChange('PriceListID', e)}
                                />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <Dropdown
                                    clearAble
                                    // required
                                    disabled
                                    className={classes.disabledDropdownCore}
                                    viewType={'outlined'}
                                    valueExpr={'TranTypeID'}
                                    displayExpr={'Description'}
                                    label={Config.lang('Nghiep_vu')}
                                    readOnly={readOnly}
                                    loading={cboTransTypeLoading}
                                    dataSource={dataCboTransType}
                                    error={error?.TransTypeID}
                                    value={dataMaster?.TransTypeID}
                                    onChange={e => onChange('TransTypeID', e)}
                                />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <TextInput
                                    // required
                                    readOnly={readOnly || cboTransTypeLoading}
                                    disabled
                                    viewType={'outlined'}
                                    value={dataMaster?.VoucherNo}
                                    error={error?.VoucherNo}
                                    label={Config.lang('So_don_hang')}
                                    onChange={e => onChange('VoucherNo', e)}
                                />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <DatePicker
                                    // required
                                    viewType={'outlined'}
                                    displayFormat={"DD/MM/YYYY"}
                                    label={Config.lang('Ngay_phieu')}
                                    readOnly={readOnly}
                                    disabled
                                    error={error?.VoucherDate}
                                    value={dataMaster?.VoucherDate}
                                    onChange={e => onChange('VoucherDate', e)}
                                />
                            </Col>
                            {/* <Col xs={12} sm={6} md={4} lg={3}>
                                <Dropdown
                                    clearAble
                                    viewType={'outlined'}
                                    valueExpr={'PaymentTermID'}
                                    displayExpr={'PaymentTermName'}
                                    label={Config.lang('Dieu_khoan_TM')}
                                    readOnly={readOnly}
                                    disabled={mode === 'edit'}
                                    loading={cboPaymentTermLoading}
                                    dataSource={dataCboPaymentTerm}
                                    value={dataMaster?.PaymentTermID}
                                    onChange={e => onChange('PaymentTermID', e)}
                                />
                            </Col> */}
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <Dropdown
                                    // required
                                    disabled
                                    className={classes.disabledDropdownCore}
                                    viewType={'outlined'}
                                    valueExpr={'WareHouseID'}
                                    displayExpr={'WareHouseName'}
                                    label={Config.lang('Kho_nhap')}
                                    readOnly={readOnly}
                                    loading={cboWarehouseLoading}
                                    dataSource={dataCboWarehouse}
                                    error={error?.WareHouseID}
                                    value={dataMaster?.WareHouseID}
                                    onChange={e => onChange('WareHouseID', e)}
                                />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <Dropdown
                                    viewType={'outlined'}
                                    valueExpr={'PaymentMethodID'}
                                    displayExpr={'PaymentMethodName'}
                                    label={Config.lang('PT_thanh_toan')}
                                    readOnly={readOnly}
                                    loading={cboPaymentMethodLoading}
                                    dataSource={dataCboPaymentMethod}
                                    value={dataMaster?.PaymentMethodID}
                                    error={error?.PaymentMethodID}
                                    onChange={e => onChange('PaymentMethodID', e)}
                                />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <Dropdown
                                    // required
                                    className={classes.disabledDropdownCore}
                                    viewType={'outlined'}
                                    valueExpr={'ID'}
                                    displayExpr={'CurrencyName'}
                                    label={Config.lang('Loai_tien')}
                                    readOnly={readOnly}
                                    disabled
                                    loading={cboCurrencyLoading}
                                    dataSource={dataCboCurrency}
                                    error={error?.CurrencyID}
                                    value={dataMaster?.CurrencyID}
                                    onChange={e => onChange('CurrencyID', e)}
                                />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <Dropdown
                                    clearAble
                                    readOnly
                                    className={classes.disabledDropdownCore}
                                    viewType={'outlined'}
                                    valueExpr={'StatusID'}
                                    displayExpr={'StatusName'}
                                    label={Config.lang('Trang_thai_duyet')}
                                    disabled
                                    loading={cboStatusLoading}
                                    dataSource={dataCboStatus}
                                    value={dataMaster?.StatusPO}
                                    renderSelectedItem={(e) => {
                                        const { FontColor = '', StatusName = '' } = e?.data || {};
                                        return <Typography style={{ color: FontColor }}>{StatusName}</Typography>
                                    }}
                                />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <TextInput
                                    readOnly
                                    disabled
                                    viewType={'outlined'}
                                    value={dataMaster?.StatusPayment}
                                    inputStyle={{ color: dataMaster?.StatusPaymentColor || '' }}
                                    label={Config.lang('Trang_thai_thanh_toan')}
                                    onChange={e => onChange('StatusPayment', e)}
                                />
                            </Col>
                            <Col xs={12} sm={12} md={8} lg={6}>
                                <TextInput
                                    multiline
                                    rows={8}
                                    maxRows={8}
                                    viewType={'outlined'}
                                    value={dataMaster?.Notes}
                                    label={Config.lang('Ghi_chu')}
                                    onChange={e => onChange('Notes', e)}
                                />
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={6}>
                                <Label className={'mgb1x'}>{Config.lang('Tai_lieu_dinh_kem')}</Label>
                                <Attachment
                                    isStripDomain
                                    height={180}
                                    style={{ minHeight: 120 }}
                                    readOnly={readOnly}
                                    domain={Config.getCDNPath()}
                                    data={dataOldAttachments}
                                    onChange={onChangeAttachments}
                                />
                            </Col>
                        </Row>
                    </AccordionDetails>
                </Accordion>
                <Col xs={12} sm={12} md={12} lg={6}>
                    <Typography type={'h4'}>{Config.lang('Thong_tin_don_hang')}</Typography>
                    <div className={'wrap align-center mgv2x'}>
                        <Button
                            viewType={'outlined'}
                            color={'primary'}
                            className={'mgr4x'}
                            startIcon={'AddFilled'}
                            disabled={readOnly || gridLoading}
                            label={Config.lang('Chon_hang_hoa')}
                            onClick={() => handleOpenInfoModal(true)}
                        />
                        <TextInput
                            delayOnChange={700}
                            viewType={'outlined'}
                            value={StrSearch}
                            endIcon={'Search'}
                            className={isMobile ? 'pdt4x' : ''}
                            readOnly={gridLoading}
                            style={{ minWidth: isMobile ? '100%' : 400 }}
                            placeholder={Config.lang('Noi_dung_can_tim')}
                            onChange={(e) => onChangeFilter('StrSearch', e)} />
                    </div>
                </Col>
                <Col xs={12} className={'pdt0'}>{renderGrid}</Col>
            </Row>
        </div>
    );
}

const InfoModal = memo(forwardRef((props, _) => {
    const classes = useStyles();
    const isMobile = window.innerWidth < 576;
    const { open, handleOpen, renderNumberInputCol, getParamGeneral, dataGridParent } = props;
    const [isEdit, setIsEdit] = useState(false);
    const [gridLoading, setGridLoading] = useState(false);
    const [checkChosenCol, setCheckChosenCol] = useState(false);

    const [chosenNum, setChosenNum] = useState(0);
    const [strSearch, setStrSearch] = useState('');
    const [dataGrid, setDataGrid] = useState([]);

    const gridRef = useRef(null);
    const chosenNumRef = useRef(null);

    useEffect(() => {
        loadPovInvGrid();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadPovInvGrid = () => {
        const params = (getParamGeneral && getParamGeneral('loadPovInvGrid')) || {};
        if (Config.isEmpty(params)) return;
        setGridLoading(true);
        props.W06F2520Actions.loadPovInv(params, (error, data) => {
            setGridLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const dataCustomGrid = data.map(item => ({ ...item, IsChose: +dataGridParent.some(item2 => item.InventoryID === item2?.InventoryID) }));
                setDataGrid(dataCustomGrid);
            }
        });
    };

    const handleChoose = async () => {
        let detail = [];
        await gridRef.current.instance.saveEditData();
        detail = gridRef.current.instance.option('dataSource') || [];
        if (!Config.isEmpty(detail)) detail = detail.filter(item => !!item?.IsChose); // Dòng có check
        const paramPlus = (getParamGeneral && getParamGeneral('ListINVDetail')) || {};
        const params = {
            StrSearch: '',
            ...paramPlus,
            data: JSON.stringify(detail)
        };
        setGridLoading(true);
        props.W06F2520Actions.onChoose(params, (error, data) => {
            setGridLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const chosenData = !Config.isEmpty(dataGridParent) ? data.filter(item1 => !dataGridParent.some(item2 => item1?.InventoryID === item2?.InventoryID)) : data;
                const oldData = !Config.isEmpty(chosenData) ? dataGridParent.filter(item1 => !chosenData.some(item2 => item1?.InventoryID === item2?.InventoryID)) : data;
                handleOpen && handleOpen(false, ([...chosenData, ...oldData]) || []); // Đóng Pop + Reload Form Cha
            }
        });
    };

    const onChoose = () => {
        handleChoose();
    };

    const onChangeFilter = (e) => {
        const value = e?.value ?? e?.target?.value ?? '';
        setStrSearch(value);
    };

    const renderChoseColumn = (e) => {
        return <Checkbox
            style={{ margin: 'auto' }}
            checked={e?.value === 1}
            onChange={(data) => {
                setIsEdit(true);
                const val = !!data?.value;
                dataGrid[e.rowIndex].IsChose = val ? 1 : 0;
                e.component.cellValue(e.rowIndex, 'IsChose', val ? 1 : 0);
                e.component.saveEditData();
                const oldVal = Number(chosenNumRef.current?.innerText) ?? 0;
                setChosenNum(val ? oldVal + 1 : oldVal - 1);
                let dataSource = e.component.option('dataSource') || [];
                if (!Config.isEmpty(dataSource)) dataSource = dataSource.filter(item => !!item?.IsChose);
                if (Config.isEmpty(dataSource)) setIsEdit(false);
            }}
        />;
    };

    const renderGridInfo = useMemo(() => {
        const dataSource = dataGrid.flatMap((item, idx) => checkChosenCol && !item?.IsChose ? [] : [{ ...item, STT: idx }]);
        return (
            <>
                <Loading size={'small'} visible={gridLoading} />
                <GridContainer
                    reference={ref => (gridRef.current = ref)}
                    pagerFullScreen={false}
                    dataSource={dataSource}
                    keyExpr={'STT'}
                    typePaging={'normal'}
                    itemPerPage={10}
                    elementAttr={{ style: 'max-height: 460px; min-height: 320px;', class: classes.infoGrid }}
                    filterRow={{
                        visible: true,
                        showOperationChooser: false,
                    }}
                    onRowUpdated={() => {
                        setIsEdit(true);
                    }}
                    onEditingStart={(e) => {
                        if (!e?.data?.IsChose) e.cancel = true; // Không check không cho Edit
                    }}>
                    <Column allowFiltering={false} width={80} alignment={'center'} dataField={'IsChose'} caption={Config.lang('Chon')} cellRender={renderChoseColumn} />
                    <Column width={200} caption={Config.lang('Ma_hang')} dataField={'InventoryID'} />
                    <Column minWidth={280} caption={Config.lang('Ten_hang')} dataField={'InventoryName'} />
                    <Column width={240} caption={Config.lang('Loai_hang')} dataField={'InventoryType'} />
                    <Column width={120} caption={Config.lang('DVT')} dataField={'UnitID'} />
                    <Column width={180} dataType={'number'} caption={Config.lang('So_luong_ton')} dataField={'WareHouseQTY'} cellRender={renderNumberInputCol} />
                    <Column width={180} dataType={'number'} caption={Config.lang('Don_gia')} dataField={'UnitPrice'} cellRender={renderNumberInputCol} />
                </GridContainer>
            </>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataGrid, gridLoading, checkChosenCol]);

    const onChange = async (fieldName, e) => {
        if (Config.isEmpty(fieldName)) return;
        let value = e?.value ?? e?.target?.value ?? '';
        // let obPlus = { [fieldName]: value };
        switch (fieldName) {
            case 'chosen':  // Điểm  dự kiện
                if (!!value) {
                    await gridRef.current.instance.saveEditData();
                    const dataSource = gridRef.current.instance.option('dataSource') || [];
                    setDataGrid(dataSource);
                }
                setTimeout(() => setCheckChosenCol(value));
                break;
            default:
                break;
        }
        setIsEdit(true);
    };

    // Modal Order 
    return (
        <Modal open={open} size={'xl'} onClose={() => handleOpen(false)}>
            <ModalHeader title={Config.lang('Thong_tin_hang_hoa')} />
            <ModalBody>
                <Row>
                    <Col xs={12}>
                        <div className={'wrap align-right align-between'}>
                            <div className={'display_row align-center'}>
                                <Checkbox
                                    className={'mgr1x'}
                                    checked={!!checkChosenCol}
                                    disabled={Config.isEmpty(dataGrid)}
                                    label={Config.lang('Hien_thi_du_lieu_da_chon')}
                                    onChange={e => onChange('chosen', e)}
                                />
                                (<Typography ref={chosenNumRef}>{chosenNum}</Typography>)
                            </div>
                            <div className={`wrap align-center ${classes.searchDiv}`}>
                                <TextInput
                                    style={{ minWidth: isMobile ? '100%' : 400 }}
                                    className={isMobile ? 'pdv2x' : ''}
                                    viewType={'outlined'}
                                    value={strSearch}
                                    endIcon={'Search'}
                                    onChange={(e) => onChangeFilter(e)}
                                    placeholder={Config.lang('Noi_dung_can_tim')} />
                                <Button
                                    viewType={'outlined'}
                                    color={'primary'}
                                    startIcon={'Search'}
                                    label={Config.lang('Tim_kiem')}
                                    className={isMobile ? '' : 'mgl4x'}
                                    onClick={() => {
                                        loadPovInvGrid();
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12}>{renderGridInfo}</Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button
                    viewType={'filled'}
                    color={'info'}
                    disabled={!isEdit || !chosenNum}
                    label={Config.lang('Chon')}
                    onClick={onChoose}
                />
            </ModalFooter>
        </Modal>
    );
}));

const UpdateStatusModal = memo(forwardRef((props, _) => {
    const { open, handleOpen, dataCboStatusPov, cboStatusPovLoading, paramSave } = props;
    const [isEdit, setIsEdit] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [error, setError] = useState({});
    const [dataMaster, setDataMaster] = useState({
        StatusID: '',
        Notes: ''
    });

    const onChange = async (fieldName, e) => {
        if (Config.isEmpty(fieldName)) return;
        const value = e?.value ?? e?.target?.value ?? '';
        const obPlus = { ...dataMaster, [fieldName]: value };
        setDataMaster(obPlus);
        if (!Config.isEmpty(value) && error?.[fieldName]) setError({ ...error, [fieldName]: '' });
        setIsEdit(true);
    };

    const checkValidateMaster = (arrName) => {
        if (Config.isEmpty(arrName)) return;
        return arrName.map(item => {
            let val = dataMaster[item];
            return {
                name: item,
                rules: ["isRequired"],
                value: val
            }
        });
    };

    const onSave = async () => {
        const resultValidate = checkValidateMaster(['StatusID']);
        const validateFrom = MForm.formValidation(resultValidate);
        if (Object.keys(validateFrom).length > 0) {
            setError(validateFrom, true);
            return false;
        }
        const params = {
            ...dataMaster,
            ...paramSave()
        };
        setFormLoading(true);
        props.W06F2520Actions.updateStatus(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (data?.Status === 0) {
                    handleOpen(false, true);
                    Config.notify.show('success', Config.lang('Luu_thanh_cong'), 2000);
                } else if (data?.Message) Config.popupCore.show('INFO', data.Message);
            }
        });
    };

    // Modal Order 
    return (
        <Modal open={open} size={'sm'} onClose={() => handleOpen(false)}>
            <ModalHeader title={Config.lang('Cap_nhat_trang_thai')} />
            <ModalBody>
                <Loading visible={formLoading} />
                <Row>
                    <Col xs={2}><Label>{Config.lang('Trang_thai')}</Label></Col>
                    <Col xs={10}>
                        <Dropdown
                            required
                            viewType={'outlined'}
                            valueExpr={'StatusID'}
                            displayExpr={'StatusName'}
                            loading={cboStatusPovLoading}
                            dataSource={dataCboStatusPov}
                            error={error?.StatusID}
                            value={dataMaster?.StatusID}
                            onChange={e => onChange('StatusID', e)}
                        />
                    </Col>
                    <Col xs={2}><Label>{Config.lang('Ghi_chu')}</Label></Col>
                    <Col xs={10}>
                        <TextInput
                            multiline
                            rows={5}
                            maxRows={5}
                            viewType={'outlined'}
                            value={dataMaster?.Notes}
                            onChange={e => onChange('Notes', e)}
                        />
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <div className={'jus-end'}>
                    <Button
                        viewType={'filled'}
                        color={'info'}
                        startIcon={'Save'}
                        disabled={!isEdit}
                        label={Config.lang('Luu')}
                        onClick={onSave}
                    />
                </div>
            </ModalFooter>
        </Modal>
    );
}));

const ApprovalModal = memo(forwardRef((props, _) => {
    const { open, handleOpen, paramSave, loadMaster, loadDetail, approvalMode } = props;
    const [formLoading, setFormLoading] = useState(false);
    const [ApprovalNote, setApprovalNote] = useState('');

    const getLabel = (mode) => {
        let color = '';
        let icon = '';
        let text = '';
        switch (mode) {
            case 'labelSave':
                if (approvalMode === 'Approval') {
                    text = Config.lang('Duyet');
                    color = 'success';
                    icon = 'Approval';
                } else {
                    text = Config.lang('Bo_duyet');
                    color = 'danger';
                    icon = 'CancelFilled';
                }
                break;
            case 'saveSuccess':
                text = approvalMode === 'Approval' ? Config.lang('Duyet_thanh_cong') : Config.lang('Bo_duyet_thanh_cong');
                break;
            default:
                break;
        }
        return { text, color, icon };
    };

    const onChange = async (fieldName, e) => {
        if (Config.isEmpty(fieldName)) return;
        const value = e?.value ?? e?.target?.value ?? '';
        setApprovalNote(value);
    };

    const approveAction = () => {
        const params = {
            ...paramSave(),
            ApprovalNote
        };
        setFormLoading(true);
        props.W06F2520Actions.approval(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (data?.Status === 0) {
                    handleOpen && handleOpen(false);
                    loadMaster();
                    loadDetail();
                    const message = data?.Message || getLabel('saveSuccess')?.text;
                    Config.notify.show('success', message, 2000);
                } else if (data?.Message) Config.popupCore.show('INFO', data.Message);
            }
        });
    };

    // Modal Order 
    return (
        <Modal open={open} size={'sm'} onClose={() => handleOpen(false)}>
            <ModalHeader title={Config.lang('Cap_nhat_trang_thai')} />
            <ModalBody>
                <Loading visible={formLoading} />
                <TextInput
                    multiline
                    rows={5}
                    maxRows={5}
                    viewType={'outlined'}
                    value={ApprovalNote}
                    label={Config.lang('Ghi_chu')}
                    onChange={e => onChange('ApprovalNote', e)}
                />
            </ModalBody>
            <ModalFooter>
                <div className={'jus-end'}>
                    <Button
                        viewType={'filled'}
                        color={getLabel('labelSave')?.color}
                        startIcon={getLabel('labelSave')?.icon}
                        label={getLabel('labelSave')?.text}
                        onClick={approveAction}
                    />
                </div>
            </ModalFooter>
        </Modal>
    );
}));

UpdateStatusModal.propTypes = {
    open: PropTypes.bool,
    cboStatusPovLoading: PropTypes.bool,
    dataCboStatusPov: PropTypes.array,
    handleOpen: PropTypes.func,
    paramSave: PropTypes.object,
};

UpdateStatusModal.defaultProps = {
    open: false,
    cboStatusPovLoading: false,
    paramSave: {},
    dataCboStatusPov: []
};

ApprovalModal.propTypes = {
    open: PropTypes.bool,
    approvalMode: PropTypes.string,
    paramSave: PropTypes.object,
    handleOpen: PropTypes.func,
    loadMaster: PropTypes.func,
    loadDetail: PropTypes.func,
};

ApprovalModal.defaultProps = {
    open: false,
    approvalMode: '',
    paramSave: {},
};

export default connect(state => ({
    decimalSetting: state.w06f2520.decimalSetting,
}), (dispatch) => ({
    W06F2520Actions: bindActionCreators(W06F2520Actions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
}))(W06F2520);


